export const LOGIN_SUCCESS = Symbol('LOGIN_SUCCESS')
export const LOGIN_FAILURE = Symbol('LOGIN_FAILURE')
export const LOGIN_NEW_PASSWORD_REQUIRED = Symbol('LOGIN_NEW_PASSWORD_REQUIRED')

export const REFRESH_SESSION_SUCCESS = Symbol('REFRESH_SESSION_SUCCESS')
export const REFRESH_SESSION_FAILURE = Symbol('REFRESH_SESSION_FAILURE')

export const CHANGE_PASSWORD_SUCCESS = Symbol('CHANGE_PASSWORD_SUCCESS')
export const CHANGE_PASSWORD_FAILURE = Symbol('CHANGE_PASSWORD_FAILURE')
export const CHANGE_PASSWORD_INCORRECT_PASSWORD = Symbol('INCORRECT_PASSWORD')
